import { h, Fragment } from 'preact'
import Post from './Post';
import USPRow from './USPRow';
import Loader from './Loader';
import OrderBy from './Orderby';
import SearchFilter from '../components/SearchFilter';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Posts = props => {
  let { posts } = props;
  const offset = props.offset;
  const activeClass = props.showAll ? 'active' : '';
  const addLabel = props.addLabel ? props.addLabel : 'Add';
  const readMoreLabel = props.readMoreLabel ? props.readMoreLabel : 'Read more';
  const suggestedLabel = props.suggestedLabel ? props.suggestedLabel : 'Suggested filters:';
  const uspOne = props.uspOne ? props.uspOne : '';
  const uspTwo = props.uspTwo ? props.uspTwo : '';
  const uspThree = props.uspThree ? props.uspThree : '';
  const suggestedAnimal = props.suggestedAnimal ? props.suggestedAnimal : '';
  const suggestedBrand = props.suggestedBrand ? props.suggestedBrand : '';
  const suggestedCategory = props.suggestedCategory ? props.suggestedCategory : '';
  const typeShop = props.typeShop ? props.typeShop : '';
  const language = (props.currentLanguage !== '') ? props.currentLanguage : 'en';
  const loggedIn = props.loggedIn ? props.loggedIn : '';
  const searchPlaceholder = props.searchText ? props.searchText : '';

  posts.map(item => {
    if ((item.link.includes('-pet')) && typeShop == 'vet') posts = posts.filter(e => !(e.link.includes('-pet') && typeShop == 'vet'));
    if ((item.link.includes('-vet')) && typeShop == 'pet') posts = posts.filter(e => !(e.link.includes('-vet') && typeShop == 'pet'));
  })

  return (
    <div className="c-shop-overview__posts u-flex">
      <div className="c-shop-overview__posts-top-bar u-flex u-flex-sb">
        <div className="c-shop-overview__posts-top-content u-flex u-flex-v-center">
          {suggestedLabel}:

          <div className="c-shop-overview__suggested-filters u-flex">
            {suggestedAnimal.length ? (
              suggestedAnimal.map(item => {
                const currentCategory = props.animals.filter(category => category.id == item);
                const currentCategoryName = (currentCategory.length >= 1) ? currentCategory[0].name : currentCategory;
                const currentCategoryID = (currentCategory.length >= 1) ? currentCategory[0].id : currentCategory;
                if (!currentCategoryName.length) return;
                return <Item handleSuggested={props.handleSuggested} id={currentCategoryID} target="currentAnimals" item={currentCategoryName} />;
              })
            ) : null }
            
            {suggestedBrand.length ? (
              suggestedBrand.map(item => {
                const currentCategory = props.brands.filter(category => category.id == item);
                const currentCategoryName = (currentCategory.length >= 1) ? currentCategory[0].name : currentCategory;
                const currentCategoryID = (currentCategory.length >= 1) ? currentCategory[0].id : currentCategory;
                if (!currentCategoryName.length) return;
                return <Item handleSuggested={props.handleSuggested} id={currentCategoryID} target="currentBrands" item={currentCategoryName} />;
              })
            ) : null }

            {suggestedCategory.length ? (
              suggestedCategory.map(item => {
                const currentCategory = props.categories.filter(category => category.id == item);
                const currentCategoryName = (currentCategory.length >= 1) ? currentCategory[0].name : currentCategory;
                const currentCategoryID = (currentCategory.length >= 1) ? currentCategory[0].id : currentCategory;
                if (!currentCategoryName.length) return;
                return <Item handleSuggested={props.handleSuggested} id={currentCategoryID} target="currentCategories" item={currentCategoryName} />;
              })
            ) : null }
          </div>
        </div>

        <SearchFilter 
          searchText=''
          onSearch={props.onSearch}
          onSubmit={props.onSubmit}
          placeholder={searchPlaceholder}
          searchActive={props.searchActive}
          isLoading={props.isLoading}
        />
      </div>

      <div class="c-shop-overview__count u-flex u-flex-sb">
        ({props.nrAll}) {props.itemsLabel}

        <div class="u-hide-on-small">
          <OrderBy
            order={props.order}
            onSelectOrder={props.handleOrderChoice}
            postsLoading={props.loading}
          />
        </div>
      </div>

      {posts.map((post, index) => {
        if (index == 6 && uspOne ) {
          return (
            <USPRow
              uspOne={uspOne}
              uspTwo={uspTwo}
              uspThree={uspThree}
            />
          )
        } else {
          if (offset == 0) {
            if (index < 14) {
              return <Post key={post.id} post={post} add={addLabel} readMore={readMoreLabel} typeShop={typeShop} language={language} loggedIn={loggedIn} />;
            }
          } else {
            return <Post key={post.id} post={post} add={addLabel} readMore={readMoreLabel} typeShop={typeShop} language={language} loggedIn={loggedIn} />;
          }
        }
      })}

      {props.loading ? <Loader /> : null}

      {props.nrAll > props.count ? (
        <div className="c-shop-overview__toggle-button-container">
          <div className="c-shop-overview__posts-count">
            {posts.length} of {props.nrAll} shown
          </div>

          <div className={`c-shop-overview__toggle-button u-flex ${activeClass}`} onClick={props.handleShowMore}>
            <div className="c-shop-overview__show-more">Load more</div>
            <div className="c-shop-overview__show-less">All loaded</div>
          </div>
        </div>
      ) : null }
    </div>
  );
};

const Item = props => {
  return (
    <div className="c-shop-filters__item c-shop-filters__suggested-item" onClick={props.handleSuggested} data-id={props.id} data-target={props.target} data-name={props.item}>
      {props.label ? props.label : props.item}
    </div>
  );
};

export default Posts;


// WEBPACK FOOTER //
// ./src/js/shop/components/Posts.js